import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ChartOptions } from 'chart.js';
import * as fileSaver from 'file-saver';
import { appConstants } from '../helpers/constants';
import { StandardApiRequest, Carrier, Account, RefundTotalByDisputeType, PerformanceByService, TrackingException, UserInfo, SurchargeTotal, RefundsByMonth } from '../helpers/interfaces';
import { ApiService } from '../services/api.service.service';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-refunds-by-month-chart',
  templateUrl: './refunds-by-month-chart.component.html',
  styleUrls: ['./refunds-by-month-chart.component.css']
})
export class RefundsByMonthChartComponent implements OnInit {

  constructor(private apiService: ApiService,  private notification: MatSnackBar, private sessionService: SessionService, private userService: UserService) { }

  displayedColumns: string[] = ['month', 'year', 'net-charge'];
  dataTable: MatTableDataSource<RefundsByMonth> = new MatTableDataSource();
  
  userInfo!: UserInfo;
  dateToday: Date = new Date();
  form: StandardApiRequest = {
    StartDate: new Date(this.dateToday.getFullYear(), 1, 1),
    EndDate: new Date(this.dateToday),
    CarrierId: 0,
    AccountId: 0,
    ClientId: 0,
    IsPageLoad: false
  }

  defaultScale = appConstants.fun.getChartScale('Month', 'Amount in Dollars');

  // [Total NET-CHARGE]
  totalRefundsByMonthData: Array<any> = [{ data: [] }];
  totalRefundsByMonthLabels: Array<any> = [];
  totalRefundsByMonthOptions: any = {
    responsive: true,
    scales: this.defaultScale,
    isLoading: true,
    tooltips: {
      enabled: true,
      mode: 'single',
      callbacks: {
        label: function (tooltipItems: { yLabel: string; }, data: any) {
          return ' $' + tooltipItems.yLabel;
        }
      }
    }
  };
  totalRefundsByMonthLegend: boolean = false;
  totalRefundsByMonthType: any = appConstants.CHARTS.TYPES.LINE_CHART;

  public totalRefundsByMonthColors: Array<any> = [{}];
  totalRefundsLoading = true;

  Carriers: Carrier[] = [{ CarrierId: 0, CarrierName: "All" }]
  Accounts: Account[] = [{ AccountId: 0, AccountNumber: "All" }]

  ngOnInit(): void {
    this.userInfo = this.userService.userInfo;
    this.sessionService.performanceForm.ClientId = this.userInfo.ClientId;
    this.form = this.sessionService.performanceForm;
    
    this.apiService.makeStandardApiCall('user/GetCarriersByClient', this.form).subscribe(
      (data: any) => {
        if (data.StatusCode != 401) {
          const carriers: Carrier[] = JSON.parse(data.Value);
          this.Carriers = [];
          this.Carriers.push({ CarrierName: 'All', CarrierId: 0 });
          carriers.forEach(element => {
            this.Carriers.push(element);
          });
        }
      }
    );
    this.updateDashboardComponents();
    this.updateAccountsList();
  }

  updateAccountsList(): void {
    this.apiService.makeStandardApiCall('user/GetAccountsByClientCarrier', this.form).subscribe(
      (data: any) => {
        if (data.StatusCode != 401) {
          const accounts: Account[] = JSON.parse(data.Value);
          this.Accounts = [];
          this.Accounts.push({ AccountNumber: 'All', AccountId: 0 });
          accounts.forEach(element => {
            this.Accounts.push({ AccountNumber: element.AccountNumber.trim().toUpperCase(), AccountId: element.AccountId });
          });
        }
      }
    );
  }

  updateDashboardComponents(): void {
    this.sessionService.performanceForm = this.form;
    this.totalRefundsLoading = true;
    this.apiService.makeStandardApiCall('values/GetRefundByMonth', this.form).subscribe(
      (data: any) => {
        const chartData = appConstants.fun.parseChartDataFromApi(JSON.parse(data.Value), 'TotalRefunds');
        this.dataTable = new MatTableDataSource<RefundsByMonth>(JSON.parse(data.Value));
        // Set values to chart
        this.totalRefundsByMonthLabels = chartData.labels;
        this.totalRefundsByMonthData[0].data = chartData.values;
        this.totalRefundsByMonthOptions.isLoading = false;
        this.totalRefundsByMonthOptions.tooltips.callbacks;
        this.totalRefundsByMonthColors = [
          {
            backgroundColor: 'rgba(255,255,255,0)',
            borderColor: 'rgba(102,163,255,1)', // Data drive this
            pointBackgroundColor: 'rgba(102,163,255,1)',
            pointBorderColor: 'rgba(102,163,255,0)',
          }
        ];
        this.totalRefundsLoading = false;
      }
    );

  }

  downloadSearch(): void {
    this.apiService.downloadFile('GetRefundsByMonthDownload', this.form).subscribe((response: any) => { //when you use stricter type checking
      let blob: any = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      fileSaver.saveAs(blob, 'RefundTotalByDispute.xlsx');
    }), (error: any) => 
      () => this.notification.open('File downloaded successfully');
  }
}
